module.exports = __webpack_public_path__ + "img/sub.aa1683be.png";